export default __webpack_public_path__ + "static/media/MaleHeadOccipital.75c441aa.png";